module.exports = __webpack_public_path__ + "img/download.0d5b93ec.svg";